import React from 'react';
import './Contact.css';
import Aos from "aos";
import "aos/dist/aos.css"
import { useEffect } from "react";

function Contact() {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  return (
    <div id="contact" className="container-fluid">
      <div className="contact-container text-center">
        <h2 className="contact-title" data-aos="fade-up" data-aos-once="true">What's Next?</h2>
        <p className="contact-text" data-aos="fade-up" data-aos-once="true">
          I'm currently seeking new opportunities and I'm always open to discussing new projects, creative ideas, or opportunities to be part of an innovative team. Feel free to reach out.
        </p>
        <a href="mailto:goelgpt@gmail.com" className="contact-button cool-btn" data-aos="fade-up" data-aos-once="true">
          Say Hello
        </a>
      </div>
      <footer className="footer-social">
        <div className="social-links">
          <a target="_blank" rel="noopener noreferrer" href="https://github.com/mridulgoel03">
            <i className="fab fa-github"></i>
          </a>
          <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/mridulgoel03/">
            <i className="fab fa-linkedin"></i>
          </a>
          <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/mridulgoel03">
            <i className="fab fa-twitter"></i>
          </a>
          <a target="_blank" rel="noopener noreferrer" href="mailto:goelgpt@gmail.com">
            <i className="fas fa-envelope"></i>
          </a>
        </div>
        <p className="footer-credit">Designed & Built by Mridul Goel</p>
      </footer>
    </div>
  );
}

export default Contact;
